import React, { useState } from 'react'
import ArrowRight from '@/icons/bwi/angle-right.svg'
import Collapsible from '@/components/ui/collapsible'
import { cx } from '@/utils/strings'
import Icon from '../icon'

type DisclosureProps = {
  heading: JSX.Element
  id?: string
  className?: string
  children: React.ReactNode
  /** Use isOpen if you want control the open state externally. It doesn't work with defaultOpen */
  isOpen?: boolean
  /** Use defaultOpen if you want the disclosure to be open initially. It doesn't work with isOpen */
  defaultOpen?: boolean
  onClick?: (isOpen: boolean) => void
  ArrowIcon?: (isOpen: boolean) => JSX.Element
}

export default function Disclosure({
  id,
  heading,
  children,
  className,
  isOpen: isExternallyOpen,
  defaultOpen = false,
  onClick,
  ArrowIcon,
}: DisclosureProps) {
  const [isInternallyOpen, setIsInternallyOpen] = useState(defaultOpen)

  const isControlled = typeof isExternallyOpen === 'boolean'
  const isOpen = isControlled ? isExternallyOpen : isInternallyOpen

  return (
    <>
      <button
        type="button"
        className={cx('flex items-center w-full text-left rounded-md py-1 px-3 hover:bg-secondary-100 ', className)}
        id={id}
        onClick={() => {
          onClick?.(!isOpen)
          if (!isControlled) setIsInternallyOpen(!isInternallyOpen)
        }}
      >
        {heading}
        {ArrowIcon?.(isOpen) || (
          <span className={cx('bwi bwi-angle-right ml-2 duration-150 text-[16px]', isOpen && 'rotate-90')} />
        )}
      </button>
      <Collapsible className="text-sm" isOpen={isOpen}>
        {children}
      </Collapsible>
    </>
  )
}
